import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const load = () => {
  try { return JSON.parse(localStorage.getItem("cs_cart") || "[]"); }
  catch { return []; }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);
  const [discount, setDiscount] = useState(() => localStorage.getItem("cs_discount") || "");

  useEffect(() => { localStorage.setItem("cs_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("cs_discount", discount); }, [discount]);

  const addItem = (product, size, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id && i.size === size);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...prev, {
        product_id: product.id, name: product.name, price: product.price,
        image: product.front_image, lookup_key: product.lookup_key,
        size, quantity, preorder: product.preorder,
      }];
    });
    setOpen(true);
  };

  const updateQty = (product_id, size, quantity) => {
    if (quantity < 1) return removeItem(product_id, size);
    setItems((prev) => prev.map((i) =>
      i.product_id === product_id && i.size === size ? { ...i, quantity } : i));
  };

  const removeItem = (product_id, size) =>
    setItems((prev) => prev.filter((i) => !(i.product_id === product_id && i.size === size)));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{
      items, open, setOpen, addItem, updateQty, removeItem, clear,
      count, subtotal, discount, setDiscount,
    }}>
      {children}
    </CartContext.Provider>
  );
};
